module.exports = __webpack_public_path__ + "img/Welfare-ren.9b7dd942.png";